import Input from './Input';
import Group from './Group';
import Search from './Search';
import TextArea from './TextArea';
export { InputProps } from './Input';
export { GroupProps } from './Group';
export { SearchProps } from './Search';
export { TextAreaProps } from './TextArea';
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
export default Input;



// WEBPACK FOOTER //
// ./components/input/index.tsx